import React from "react";

const Dashboard = ({ location }) => {
  // ==================================

  return <></>;
};

export default Dashboard;
